import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <a href="https://www.itaysolutions.com" target="_blank" rel="noopener noreferrer" className="footer-link">
          <span className="footer-powered">Powered by</span>
          <span className="footer-brand">ItaySolutions</span>
          <span className="footer-tagline">פתרונות דיגיטליים</span>
        </a>
        <p className="footer-copyright">
          © {new Date().getFullYear()} כל הזכויות שמורות
        </p>
      </div>
    </footer>
  );
}

export default Footer;